$(function () {

  $(document).on('scroll', onScroll);

  $('.sb-sticky__link[href^="#"]').on('click', function (event) {
    event.preventDefault();

    $(document).off('scroll');

    $('.sb-sticky__link[href^="#"]').each(function () {
      $(this).removeClass('is-active');
    });

    $('html').removeClass('is-sticky-open');
    $(this).addClass('is-active');

    let target = this.hash,
      $target = $(target),
      $targePos = $target.offset().top - 50;

    $('html, body').stop().animate({
      'scrollTop': $targePos,
    }, 500, 'swing', function () {
      $(document).on('scroll', onScroll);
    });

  });
  $('.lowscroll[href^="#"]').on('click', function (event) {
    event.preventDefault();

    $(document).off('scroll');

    let target = this.hash,
      $target = $(target),
      $targePos = $target.offset().top - 50;

    $('html, body').stop().animate({
      'scrollTop': $targePos,
    }, 500, 'swing', function () {
      $(document).on('scroll', onScroll);
    });

  });

  function onScroll () {

    let scrollPos = $(document).scrollTop();

    $('.sb-sticky__link[href^="#"]').each(function () {

      let currLink = $(this);
      let refElement = $(currLink.attr('href'));
      if (refElement.offset().top - 60 <= scrollPos) {
        $('.sb-sticky__link').removeClass('is-active');
        currLink.addClass('is-active');
      }else {
        currLink.removeClass('is-active');
      }

    });

  }

  // --------------------------------------------------------------------------
  // Stycky
  // --------------------------------------------------------------------------

  function sticky () {

    let offsetScroll = window.pageYOffset || document.documentElement.scrollTop;

    if ($('.js-sticky-trigger').length) {
      if (offsetScroll > $('.js-sticky-trigger').offset().top - 70) {
        $('html').addClass('is-sticky');
      }else {
        $('html').removeClass('is-sticky');
      }
    }

  }

  sticky();

  $(window).on('scroll', function (event) {
    sticky();
  });

  // --------------------------------------------------------------------------
  // Tabs
  // --------------------------------------------------------------------------

  $('.js-tabs').on('click', '[data-tabs]', function (event) {
    event.preventDefault();
    let tabsData = $(this).attr('data-tabs'),
      tabsText = $(this).text();

    $(this).closest('.js-tabs').removeClass('is-tabs-open');

    $('[data-tabs-selected]').text(tabsText);

    $(this).closest('.js-tabs').find('[data-tabs]').removeClass('is-active');
    $(this).addClass('is-active');

    $(this).closest('.js-tabs').find('[data-tabs-panel]').removeClass('is-active');

    $('[data-tabs-panel=' + tabsData + ']').addClass('is-active');

  });

  $('.js-tabs').on('click', '[data-tabs-selected]', function (event) {
    event.preventDefault();
    if ($(this).closest('.js-tabs').is('.is-tabs-open')) {

      $(this).closest('.js-tabs').removeClass('is-tabs-open');

    }else {
      $(this).closest('.js-tabs').addClass('is-tabs-open');
    }
  });

  // ------

  $('.sb-accordion').find('.sb-accordion__item').first().addClass('is-open').find('.sb-accordion__content').slideDown('fast');

  $('.sb-accordion').on('click', '.sb-accordion__btn', function (event) {
    event.preventDefault();

    if ($(this).closest('.sb-accordion__item').is('.is-open')) {
      $(this).closest('.sb-accordion__item').removeClass('is-open').find('.sb-accordion__content').slideUp('fast');
    }else {
      $('.sb-accordion').find('.sb-accordion__item').removeClass('is-open').find('.sb-accordion__content').slideUp('fast');
      $(this).closest('.sb-accordion__item').addClass('is-open').find('.sb-accordion__content').slideDown('fast');
    }

  });

  // -----

  $('.sb-price__item-more').on('click', 'a', function (event) {
    event.preventDefault();
    if ($(this).closest('.sb-price__item').is('.is-open')) {

      $(this).text('подробнее').closest('.sb-price__item').removeClass('is-open').find('.sb-price__item-text').slideUp('fast');

    }else {
      $(this).text('свернуть').closest('.sb-price__item').addClass('is-open').find('.sb-price__item-text').slideDown('fast');
    }

  });

  // ------

  $('.js-slick-hotel').slick({
    dots: true,
    arrows: false,
    infinite: true,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 10000,
  });

  $(document).on('click', '.slick-dots', function (event) {
    event.preventDefault();
  });

  // ------

  $('.js-slick-gallery').slick({
    dots: true,
    arrows: true,
    rows: 2,
    slidesPerRow: 3,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          rows: 2,
          slidesPerRow: 1,
          arrows: false,
        },
      },
    ],
  });

  // -----

  $('.js-slick-reviews').slick({
    dots: true,
    //arrows: false,
    infinite: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('.js-slick-free').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 2,
    responsive: [
      // {
      // 	breakpoint: 1200,
      // 	settings: {
      // 		slidesToShow: 2,
      // 	}
      // },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        },
      },
    ],
  });

  // ------

  $('.js-popup').fancybox({
    padding: 0,
    margin: 20,
    fitToView: false,
    autoSize: false,
    height: 'auto',
    maxWidth: 768,
    tpl: {
      wrap: '<div class="fancybox-wrap fancybox-wrap--sb" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
    },
    helpers: {
      overlay: {
        closeClick: true,
        speedOut: 200,
        showEarly: false,
        locked: true,
      },
    },
  });

});





